import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import './BKInput.css';

const BKInput = ({
  label,
  value,
  onChange,
  placeholder = 'Nhập dữ liệu',
  type = 'text',
  disabled = false,
  required = false,
  error = false,
  errorMessage = '',
  prefix = null,
  suffix = null,
  maxLength = null,
  minLength = null,
  width = '100%',
  minWidth = '170px',
  name = 'input_value',
  allowClear = false,
  autoComplete,
  ...restProps
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = React.useRef(null);

  const handleChange = (e) => {
    onChange({
      target: {
        name,
        value: e.target.value
      }
    });
  };

  const handleTogglePassword = () => {
    const cursorPosition = inputRef.current?.input?.selectionStart;
    setShowPassword(!showPassword);

    // Restore cursor position after state update
    setTimeout(() => {
      if (inputRef.current?.input) {
        inputRef.current.input.setSelectionRange(
          cursorPosition,
          cursorPosition
        );
      }
    }, 0);
  };

  const isPasswordType = type === 'password';
  const inputType = isPasswordType && !showPassword ? 'password' : 'text';

  const passwordSuffix = isPasswordType ? (
    <span
      onClick={handleTogglePassword}
      style={{ cursor: 'pointer', color: '#6b7280' }}>
      {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
    </span>
  ) : (
    suffix
  );

  // Set default autoComplete value based on type
  const autoCompleteValue =
    autoComplete !== undefined
      ? autoComplete
      : isPasswordType
        ? 'new-password'
        : 'off';

  return (
    <div className="bk-input-container" style={{ width, minWidth }}>
      {label && (
        <label className="bk-input-label">
          {label}
          {required && <span className="bk-input-required">*</span>}
        </label>
      )}
      <Input
        ref={inputRef}
        type={inputType}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        minLength={minLength}
        prefix={prefix}
        suffix={passwordSuffix}
        allowClear={allowClear}
        autoComplete={autoCompleteValue}
        status={error ? 'error' : ''}
        className={`bk-input ${error ? 'bk-input-error' : ''}`}
        {...restProps}
      />
      {error && errorMessage && (
        <div className="bk-input-error-message">{errorMessage}</div>
      )}
    </div>
  );
};

BKInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  allowClear: PropTypes.bool,
  autoComplete: PropTypes.string
};

export default BKInput;
